import { Helmet } from 'react-helmet-async';
import Carousel from './Carousel';
import AboutMe from './AboutMe';
import MediaCard from '../Media/MediaCard';
import PalapaRingTengah from './PalapaRingTengah';
import PenggunaLayanan from './PenggunaLayanan';
import BannerFooter from './BannerFooter';

function HomeLayout() {
    return (
        <>
            <Helmet>
                <title>PT Len Telekomunikasi Indonesia - Konektivitas Berkualitas</title>
                <meta
                    name="description"
                    content="PT Len Telekomunikasi Indonesia (LTI) membangun Palapa Ring Tengah untuk menyediakan konektivitas berkualitas di seluruh Indonesia, termasuk daerah 3T."
                />
                <link rel="canonical" href="https://www.len-telko.co.id/" />

                {/* Open Graph */}
                <meta property="og:title" content="PT Len Telekomunikasi Indonesia - Konektivitas Berkualitas" />
                <meta property="og:description" content="Palapa Ring Tengah oleh PT LTI mendukung pemerataan konektivitas digital Indonesia." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.len-telko.co.id/" />
                <meta property="og:image" content="https://www.len-telko.co.id/logo512.png" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="PT Len Telekomunikasi Indonesia - Konektivitas Berkualitas" />
                <meta name="twitter:description" content="PT LTI membangun jaringan serat optik Palapa Ring Tengah untuk mendukung ekonomi digital Indonesia." />
                <meta name="twitter:image" content="https://www.len-telko.co.id/logo512.png" />

                {/* Schema.org Organization */}
                <script type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "Organization",
                            "name": "PT Len Telekomunikasi Indonesia",
                            "url": "https://www.len-telko.co.id",
                            "logo": "https://www.len-telko.co.id/logo512.png",
                            "sameAs": [
                                "https://www.facebook.com/len.telko/",
                                "https://www.instagram.com/len.telko/",
                                "https://www.linkedin.com/company/len-telko/"
                            ],
                            "contactPoint": [
                                {
                                    "@type": "ContactPoint",
                                    "telephone": "+62-21-22908460",
                                    "contactType": "Customer Service",
                                    "areaServed": "ID",
                                    "availableLanguage": ["Indonesian", "English"]
                                }
                            ]
                        })
                    }}
                />
            </Helmet>


            {/* Konten Home */}
            <Carousel />
            <AboutMe />
            <MediaCard />
            <PalapaRingTengah />
            <PenggunaLayanan />
            <BannerFooter />
        </>
    );
}

export default HomeLayout;
